import Rating from './Rating'
import RatingItem from './RatingItem'

export default {
    Rating,
    RatingItem
}



// WEBPACK FOOTER //
// ./src/mixins/index.js